import React, {useState} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../Store/Reducers";
import {ModalActions} from "../../../Store/Modal/Slice";
import {PICKUP_MODAL} from "../../../Store/Modal/Types";
import {Button, ButtonGroup} from "@material-ui/core";
import {faSave, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import ShipmentFormComponent from "../../Shipment/ShipmentFormComponent";
import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {Customer} from "../../../Models/Customer";
import moment from "moment";
import {getModelName} from "../../../Utils/Utils";
import {PickupActions} from "../../../Store/Pickup/Slice";

const CreateShipmentModalComponent = () => {

  const {
    ModalReducer: {pickupModal : {open}},
    LoadingReducer: {loadingSavePickup},
    CompanyReducer: {company_selected, branch_selected},
    authReducer: {currentBranch}
  } = useSelector((state: RootState) => state);

  const dispatch = useDispatch();

  const [comments,setComments] = useState<string>('');

  const closeModal = () => {
    dispatch(ModalActions.closeModal({modal: PICKUP_MODAL}));
  };


  const shipmentForm = useForm({
    mode: "all",
    defaultValues: {
      branch: {label: currentBranch.label!, value: currentBranch._KEY},
      paying_customer: getModelName(branch_selected as Customer || company_selected as Customer),
      contact_call: '',
      insert_date: new Date(),
      call_date: new Date(),
      isCompleted: false,
      bill_to: "",
      express: false,
      pickup_time_from: new Date(),
      pickup_time_to: new Date(moment(new Date()).add(1, 'hour').format("YYYY-MM-DD hh:mm:ss a")),
      contact_pickup: '',
      address: {
        address: '',
        _KEY: '',
        city: {
          name: '',
          _KEY: ''
        }
      },
      packing_type: '',
      payment_type: ''
    }
  });

  const {handleSubmit, register, setValue, getValues, setError, clearErrors} = shipmentForm;

  const onSubmit: SubmitHandler<any> = (data: any) => {
    data.paying_customer = (branch_selected as Customer)?._KEY || (company_selected as Customer)?._KEY;
    data.address = data.address._KEY;
    data.contact_call = data.contact_call?._KEY;
    data.contact_pickup = data.contact_pickup._KEY;
    data.packing_type = data.packing_type.value;
    data.payment_type = data.payment_type.value;
    data.branch = data.branch.value;
    data.insert_date = new Date();
    if(comments?.length) data.comment = comments;

    delete data.phone;

    dispatch(PickupActions.savePickup(data));
  };

  return (
    <Modal size="lg" toggle={closeModal} isOpen={open}>
      <ModalHeader className="border-0 text-uppercase" toggle={closeModal}>
        Crear envio
      </ModalHeader>
      <ModalBody>
        <FormProvider {...shipmentForm} >
          <ShipmentFormComponent setValue={setValue}
                                 register={register}
                                 getValues={getValues}
                                 setError={setError}
                                 setComments={setComments}
                                 comments={comments}
                                 clearErrors={clearErrors}/>
        </FormProvider>
      </ModalBody>
      <ModalFooter className="border-0">
        <ButtonGroup disableElevation variant="contained">
          <Button onClick={closeModal} color="secondary"> <FontAwesomeIcon className="mr-2"
                                                                           icon={faTimes}/> Cerrar</Button>
          <Button onClick={handleSubmit(onSubmit)} disabled={loadingSavePickup.status.isLoading()} color="primary">
            <FontAwesomeIcon className="mr-2" icon={faSave}/>
            {loadingSavePickup.status.isLoading() &&
            <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"/>}
            Crear
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
};

export default CreateShipmentModalComponent;
